// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './environment.model'

export const environment: Environment = {
  production: false,
  msalClientId: 'fd7d6f2c-9cf0-44a1-9af8-348cd746e747',
  msalAuthority: 'https://login.microsoftonline.com/e2f449a1-4cf6-43e3-911c-74f3ca9744f3',
  msalRedirectUri: 'https://trakr-dev.embracepetinsurance.com/static/callback.html',
  msalProtectedApiScopes: ['api://1a831672-24d7-42cd-b9dc-167e66974f42/.default'],
  apiBase: 'https://trakr-dev.embracepetinsurance.com/api',
  apiVersion: 'v1',
  crmBaseUrl: 'https://crm-upgrade365.embracepetinsurance.com/EmbraceCRMUpgrade365/',
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error' // Included with Angular CLI.
